module.exports = __webpack_public_path__ + "img/WbCloudyOutlined.25ad2404.svg";